export default __webpack_public_path__ + "bc85b58ae93c7188fd14a0178a982341.svg";